import listActions from 'src/modules/presupuesto/list/presupuestoListActions';
import PresupuestoService from 'src/modules/presupuesto/presupuestoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'PRESUPUESTO_DESTROY';

const presupuestoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: presupuestoDestroyActions.DESTROY_STARTED,
      });

      await PresupuestoService.destroyAll([id]);

      dispatch({
        type: presupuestoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.presupuesto.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/presupuesto');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: presupuestoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: presupuestoDestroyActions.DESTROY_ALL_STARTED,
      });

      await PresupuestoService.destroyAll(ids);

      dispatch({
        type: presupuestoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.presupuesto.destroyAll.success'),
      );

      getHistory().push('/presupuesto');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: presupuestoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default presupuestoDestroyActions;
